import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import LoadingPanel from "module-common/LoadingPanel";
import InputRow from "module-common/InputRow"
import { graphql, compose } from "react-apollo";
import { mutationEditContact, queryGetBulkSmsContactTagList } from 'Apollo'
import FieldRowWithDropdown from '../../campaign/FieldRowWithDropdown'
import { mutationAddContact } from "../../../Apollo";
export default compose(
  graphql(mutationEditContact, {
    name: 'editContact'
  }),
  graphql(mutationAddContact, {
    name: 'addContact'
  }),
  graphql(queryGetBulkSmsContactTagList, {
    name: 'getTagList',
    options: {
      fetchPolicy: 'network-only'
    }
  })
)(
  class AddContact extends Component {
    state = {
        firstName: this.props.firstName,
        lastName: this.props.lastName,
        phoneNumber: this.props.phoneNumber,
        selectedTagList: this.props.selectedTagList || [],
        isSending: false
    }

    textFields = [
        {
            label: 'First Name',
            stateName: 'firstName',
            required: true
        },
        {
            label: 'Last Name',
            stateName: 'lastName',
            required: true
        },
        {
            label: 'Phone Number',
            stateName: 'phoneNumber',
            required: true
        },
        
    ]

    onSend = async () => {
        const { firstName, lastName, phoneNumber, selectedTagList } = this.state
        const { contactId, onSuccess, accountId } = this.props
        let result = null
        try {
          this.setState(state => ({...state, isSending: true}))
          if(!contactId) {
            result = await this.props.addContact({
              variables: {
                accountId: accountId,
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                tagList: selectedTagList.map(item => item.id)
              },
              refetchQueries: ['getBulkSmsContactList', 'queryGetBulkSmsContactList']
            })
          } else {
            result = await this.props.editContact({
              variables: {
                contactId: contactId,
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                tagList: selectedTagList.map(item => item.id)
              },
              refetchQueries: ['getBulkSmsContactList', 'queryGetBulkSmsContactList']
            })
          }
          
          this.flushPanelData()
          if(onSuccess) onSuccess()
        } catch(e) {
          console.log(e, "Error on updating / creating draft!")

        } finally {
          this.setState(state => ({...state, isSending: false}))
        }
        return result
    }

    flushPanelData = () => {
      this.setState(state => ({
          ...state,
          firstName: null,
          lastName: null,
          phoneNumber: null,
          selectedTagList: this.props.selectedTagList || []
      }))
  }

    onCancel = () => {
      if(this.props.onCancel) this.props.onCancel()
    }

    render() {
        const { getTagList: { getBulkSmsContactTagList }} = this.props
        const { isSending, selectedTagList } = this.state
        const tagListOptions = getBulkSmsContactTagList ? getBulkSmsContactTagList.map(item => ({
          label: item.displayName,
          value: item.id,
          selected: selectedTagList.find(existing => existing.id == item.id)
        })) : []
        return (    
        <WrapperPost>            
            <Wrap>
                {this.textFields.map(({ label, stateName, required, type }) => {
                        return <InputRow 
                            key={label}
                            label={label}
                            value={this.state[stateName]}
                            type={type}
                            inputWidth={"100%"}
                            onChange={text => this.setState(state => ({...state, [stateName]: text }))}
                            containerWidth="100%"
                        />
                })}     
                <FieldRowWithDropdown 
                  key="tagList"
                  label="Tag"
                  options={tagListOptions}
                  onChange={selected => {
                    this.setState(state => ({...state, selectedTagList: selected.map(item => ({ id: item.value }))}))
                  }}                       
                />            
            </Wrap>
            <Bottom>
                <LeftBottom></LeftBottom>
                <RightBottom>
                    <SendButton onClick={() => this.onSend()}>
                      Save
                    </SendButton>
                    <SendButton onClick={() => this.onCancel()}>
                      Cancel
                    </SendButton>
                </RightBottom>
            </Bottom>
        </WrapperPost>
        );
    }
  }
)


const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;

const Overlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: gray;
  opacity: 0.2;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin: 5px 20px 10px;
  position: relative;
`;
const WrapperSchedule = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const Border = styled.div`
  display: flex;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${props => props.theme.panelBackground};
  box-shadow: ${props => props.theme.shadow};
  margin: 10px;
  flex-direction: column;
  ${props => props.width && css`width: ${props.width};`}
`;
const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;


const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;

const Wrap = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  padding-left: 5px;
  width: 50%;
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 45%;
  align-items: center;
  padding: 3px 20px 3px 20px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 10px 10px 0 10px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/contact/member/AddContact.js